import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { LabeledInfo } from 'ui-components/components/labeled-info-list/labeled-info';

import messages from '../../messages';

const AdjustmentId = ({ data: adjustmentId }) => {
  const intl = useIntl();
  return <LabeledInfo label={intl.formatMessage(messages.adjustmentId)}>{adjustmentId}</LabeledInfo>;
};

AdjustmentId.propTypes = {
  data: PropTypes.string.isRequired,
};

export default AdjustmentId;
